export const socialsData = {
  github: "https://github.com/virinchimanepalli",
  linkedIn: "https://www.linkedin.com/in/virinchi-manepalli-b05790175/",
  twitter: "https://twitter.com/VirinchiManepa4",
  stackOverflow: "https://stackoverflow.com/users/11764384/virinchi-manepalli",
  mail: "virinchi.msk83@gmail.com",
};
